// Per-row preview diff. A status pill per row; conflict rows tinted so
// the operator sees exactly which slugs block the import.

import { Pill, type PillTone } from "../../components/ui/Pill";
import { Table } from "../../components/ui/Table";
import type { PreviewRow, RowStatus } from "../../api/types/layoutImport";

const TONE: Record<RowStatus, PillTone> = {
  new: "ok",
  "existing-match": "neutral",
  conflict: "crit",
};

const LABEL: Record<RowStatus, string> = {
  new: "New",
  "existing-match": "Existing",
  conflict: "Conflict",
};

export function PreviewDiffTable({
  rows,
  applyUpdates = false,
}: {
  rows: PreviewRow[];
  applyUpdates?: boolean;
}) {
  // In update mode a "conflict" row will be applied as an update — show it
  // amber "Update" rather than red "Conflict".
  const tone = (s: RowStatus) =>
    applyUpdates && s === "conflict" ? "warn" : TONE[s];
  const label = (s: RowStatus) =>
    applyUpdates && s === "conflict" ? "Update" : LABEL[s];

  return (
    <Table<PreviewRow>
      columns={[
        {
          key: "status",
          header: "Status",
          render: (r) => <Pill tone={tone(r.status)}>{label(r.status)}</Pill>,
        },
        { key: "floor_slug", header: "Floor", render: (r) => <code>{r.floor_slug}</code> },
        { key: "area_slug", header: "Area", render: (r) => <code>{r.area_slug}</code> },
        {
          key: "canonical_slug",
          header: "Device slug",
          render: (r) => (
            <code style={{ fontSize: "0.78rem" }}>{r.canonical_slug}</code>
          ),
        },
        { key: "device_class", header: "Class", render: (r) => r.device_class },
      ]}
      rows={rows}
      rowKey={(r) => `${r.row_number}:${r.canonical_slug}`}
    />
  );
}
